import dayjs from 'dayjs';

import {
    YandexStoryFileUploaderType,
    YandexStoryFormFieldsEnum,
    YandexStoryFormType,
    YandexStoryType,
} from '../../../service/yandex-stories/yandex-stories-type';

export const YANDEX_STORY_MIN_IMAGE_WIDTH = 100;
export const YANDEX_STORY_MIN_IMAGE_HEIGHT = 68;

export const YANDEX_STORY_MAX_IMAGE_WIDTH = 5000;
export const YANDEX_STORY_MAX_IMAGE_HEIGHT = 5000;

export const YANDEX_STORY__MAX_SLIDES = 10;

export function getYandexStoryFormInitialValues(
    storyData: YandexStoryType
): Omit<YandexStoryFormType, YandexStoryFormFieldsEnum.CompaniesSelector> {
    const formSlides = storyData.slides.reduce(
        (accumulator, slide) => ({
            ...accumulator,
            [slide.image.id]: {
                id: slide.image.id,
                url: slide.image.url,
                order: slide.order,
                buttonConfig: slide.buttonConfig,
                name: '',
                uid: slide.image.id,
                status: 'done' as const,
            },
        }),
        {} as YandexStoryFileUploaderType
    );

    const firstSlideButtonConfig = storyData.slides?.[0]?.buttonConfig;

    const isSameButtonOnEachSlide = Boolean(
        firstSlideButtonConfig &&
            storyData.slides.every((slide) => {
                return (
                    slide.buttonConfig?.link === firstSlideButtonConfig.link &&
                    slide.buttonConfig?.text === firstSlideButtonConfig.text
                );
            })
    );

    return {
        [YandexStoryFormFieldsEnum.Name]: storyData.name,
        [YandexStoryFormFieldsEnum.Slides]: formSlides,
        [YandexStoryFormFieldsEnum.Type]: storyData.type,
        [YandexStoryFormFieldsEnum.SameButtonOnEachSlide]: isSameButtonOnEachSlide,
        [YandexStoryFormFieldsEnum.Cover]: storyData.cover,
        [YandexStoryFormFieldsEnum.AutoAddCompanies]: false,
        [YandexStoryFormFieldsEnum.PublicationRange]:
            storyData.publishAt || storyData.deleteAt
                ? [
                      storyData.publishAt ? dayjs(storyData.publishAt) : null,
                      storyData.deleteAt ? dayjs(storyData.deleteAt) : null,
                  ]
                : null,
    };
}

export const YANDEX_SELECT_COMPANIES_STEP_WIDTH = 1080;
export const YANDEX_CONTENT_STEP_WIDTH = 704;

// Product limit for the story name, matching the `0 / 14` counter in the design (BST-6727).
export const YANDEX_STORY_MAX_NAME_LENGTH = 14;

// Seconds are irrelevant for scheduling and the default format does not fit the date fields. Carried
// over from the confirmation step this branch merged away (BST-10587).
export const YANDEX_STORY_DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm';
export const YANDEX_STORY_TIME_FORMAT = 'HH:mm';
